<template>
    <div>
        <div class="container container--small pdt-50 ">
            <div class="t-headline5 font-b mgt-50 mgb-16 t-center">{{$t('1526')}}</div>
            <div class="t-body1 font-r t-color-bodyGrayA t-center l-spacing48 pdl-24 pdr-24">
            {{$t('1527')}}<br>
            {{$t('1528')}}
            </div>
            <div class="pdl-24 pdr-24">
                <div class="mgt-50">
                    <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText w-full b-radius4" @click="$moveLogin()" @keypress="$moveLogin()" tabindex="0">
                        <div class="mdc-button__ripple"></div>
                        <span class="mdc-button__label t-body2 font-r">{{$t('1529')}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 회원가입 - 소셜 계정 존재 컴포넌트(sign up - exist social account component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
export default {
    data() {
        return {
            brandLogo: localStorage.brandLogo,
        }
    },
    mounted() {
        this.setMaterialUi()
    },
    methods: {
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    }
}
</script>